var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"mr-2",attrs:{"x-small":"","dark":"","color":_vm.orderStatus.color}},[_vm._v(" "+_vm._s(_vm.orderStatus.name)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }